module.exports = __webpack_public_path__ + "img/satellite.4eef0aee.webp";